(ns practitest.frontend.comment-tab
  (:require
    [practitest.frontend.common.utils :as utils]
    [re-frame.core :as re-frame]
    [cljs.reader :as reader]
    [practitest.frontend.init :as init]
    [practitest.frontend.components.comments :as comments]
    [practitest.frontend.events :as events]
    [practitest.frontend.subs :as subs]
    [ajax.core :as ajax]))

;; We expect it to be single component for now
(re-frame/reg-sub
  ::commment-tab-state
  (fn [db _]
    (:comments-tab db)))

(re-frame/reg-sub
  ::comments-data
  :<- [::commment-tab-state]
  (fn [state [_ entity-type entity-id]]
    (or (get-in state [entity-type entity-id :comments])
        [])))

(defn fetch-comments [{db :db} [_ comments-uri entity-type entity-id]]
  {:db (update db :progress conj [::fetch-comments entity-type entity-id])
   :http-xhrio
   {:method          :get
    :uri             comments-uri
    :response-format (ajax/json-response-format {:keywords? true})
    :on-success      [::got-comments entity-type entity-id]
    :on-failure      [::events/api-error [::fetch-comments entity-type entity-id] {}]}})

(re-frame/reg-event-fx
  ::fetch-comments
  fetch-comments)

(defn got-comments [db [_ entity-type entity-id data]]
  (-> db
      (assoc-in [:comments-tab entity-type entity-id :comments] (:data data))
      (update :progress disj [::fetch-comments entity-type entity-id])))

(re-frame/reg-event-db
  ::got-comments
  got-comments)

(defn root-view [{:keys [data-comments-uri
                         data-entity-id
                         data-entity-type
                         data-enable-comments]
                  :as   attrs}]

  (let [entity-type (keyword data-entity-type)
        entity-id data-entity-id
        enable-comments (reader/read-string data-enable-comments)
        reload-event [::fetch-comments data-comments-uri entity-type entity-id]]

    [comments/comments-control
     {:data-query                  [::comments-data entity-type entity-id]
      :fetch-progress-query        [::subs/progress? [::fetch-comments entity-type entity-id]]
      :small_screen                        1
      :entity-type                 entity-type
      :entity-id                   entity-id
      :enable-comments             enable-comments
      :on-comment-added-dispatch   reload-event
      :on-comment-edited-dispatch  reload-event
      :on-comment-deleted-dispatch reload-event}]))

(defn ^:dev/after-load remount-roots []
  ;; remount all comment item components on page
  (init/remount-roots "comment-item-component"
                      root-view))

(utils/register-webcomponent! "comment-item-component")
